import { IMultiLineBehavior } from "./IMultiLineBehavior";

export interface IMultiLineBehaviorSpecifiable {
  multiLineBehavior: IMultiLineBehavior;
}

export function instanceOfIMultiLineBehaviorSpecifiable(instance: any): instance is IMultiLineBehaviorSpecifiable {
  return instance
    && (instance.multiLineBehavior !== undefined);
}
